import axios from '../lib/axios';

const BASE = '/api/super-admin';

// ── Tenants ──

export const getTenants = () =>
    axios.get(`${BASE}/tenants`).then(r => r.data);

export const createTenant = (data) =>
    axios.post(`${BASE}/tenants`, data).then(r => r.data);

export const updateTenant = ({ id, ...data }) =>
    axios.put(`${BASE}/tenants/${id}`, data).then(r => r.data);

export const deleteTenant = (id, confirmationText) =>
    axios.delete(`${BASE}/tenants/${id}`, { data: { confirmation_text: confirmationText } }).then(r => r.data);

export const cloneTenant = (tenantId, data) =>
    axios.post(`${BASE}/tenants/${tenantId}/clone`, data).then(r => r.data);

export const getTenantStats = (id) =>
    axios.get(`${BASE}/tenants/${id}/stats`).then(r => r.data);

// ── Módulos y funciones por tenant ──

/** Catálogo de módulos administrables (no depende del tenant). */
export const getModulesCatalog = () =>
    axios.get(`${BASE}/modules-catalog`).then(r => r.data);

/** Estado resuelto de los módulos de un tenant. */
export const getTenantModules = (tenantId) =>
    axios.get(`${BASE}/tenants/${tenantId}/modules`).then(r => r.data);

export const updateTenantModules = (tenantId, modules) =>
    axios.put(`${BASE}/tenants/${tenantId}/modules`, { modules }).then(r => r.data);

// ── Users per Tenant ──

export const getTenantUsers = (tenantId) =>
    axios.get(`${BASE}/tenants/${tenantId}/users`).then(r => r.data);

export const createTenantUser = (tenantId, data) =>
    axios.post(`${BASE}/tenants/${tenantId}/users`, data).then(r => r.data);

export const toggleUserActive = (userId) =>
    axios.patch(`${BASE}/users/${userId}/toggle-active`).then(r => r.data);

export const exportTenantConversations = (tenantId) =>
    axios.get(`${BASE}/tenants/${tenantId}/export-conversations`).then(r => r.data);

// ── Inventory Sync on behalf of tenants ──

export const getSuperAdminSyncSettings = (tenantId = null, sourceTenantId = null) =>
    axios.get(`${BASE}/inventory/settings`, { params: { tenant_id: tenantId, source_tenant_id: sourceTenantId } }).then(r => r.data);

export const getSuperAdminSpreadsheets = (tenantId, source, sourceTenantId = null, search = '') =>
    axios.get(`${BASE}/inventory/spreadsheets`, { params: { tenant_id: tenantId, source, source_tenant_id: sourceTenantId, search } }).then(r => r.data);

export const getSuperAdminSpreadsheetTabs = (tenantId, source, sourceTenantId = null, spreadsheetId) =>
    axios.get(`${BASE}/inventory/spreadsheets/${spreadsheetId}/tabs`, { params: { tenant_id: tenantId, source, source_tenant_id: sourceTenantId } }).then(r => r.data);

export const triggerSuperAdminSync = (data) =>
    axios.post(`${BASE}/inventory/sync-inventory`, data).then(r => r.data);

export const impersonateUser = (userId) =>
    axios.post(`${BASE}/users/${userId}/impersonate`).then(r => r.data);

// ── Global System Settings (OpenRouter API Key, etc.) ──

export const getSystemSettings = () =>
    axios.get(`${BASE}/system-settings`).then(r => r.data);

export const updateSystemSettings = (data) =>
    axios.post(`${BASE}/system-settings`, data).then(r => r.data);


